<template>
    <div class="ag-search">        
        <app-popover class="search__popover" ref="popover" v-if="!searchType" placement="bottom-start"
             :horizontalOffset="horizontalOffset" :forceVisible="forceVisible"
             :verticalOffset="verticalOffset" :useScroll="true">
            <template slot="triggerer">
                <div @mousedown="openSearch()" ref="input" style="width: 100%">
                    <slot name="input"></slot>
                </div>
            </template>
            <template slot="content">
                <div v-for="item in items" :key="item.id" @click="onSearchItemClick(item)">
                    <div class="content-item">
                        <slot name="item" :item="item"></slot>
                    </div>
                </div>
                <div v-if="!items.length">
                    {{ notFoundMessage }}
                </div>
            </template>
        </app-popover>
        <app-popover class="search__popover" ref="popover" v-if="searchType === 'addresses'" placement="bottom-start"
             :horizontalOffset="horizontalOffset" :forceVisible="forceVisible"
             :verticalOffset="verticalOffset" :useScroll="true">
            <template slot="triggerer">
                <div @mousedown="openSearch()" ref="input" style="width: 100%">
                    <slot name="input"></slot>
                </div>
            </template>
            <template slot="content">
                <div v-for="item in items" :key="item.id" >
                    <div class="content-item" @click="onSearchItemClick(item)">
                        <slot name="item" :item="item"></slot>
                    </div>
                </div>
                <div v-if="!items.length">
                    Nenhum endereço encontrado.
                </div>
            </template>
        </app-popover>
        <div class="search__request" v-if="searchType === 'contacts'" >
            <div>
                <div ref="input" style="width: 100%">
                    <slot name="input"></slot>
                </div>
            </div>
            <app-perfect-scrollbar>
                <div style="display: inline;">
                    <div class="search-result--row" v-for="(item, index) in items" :key="index" style="width: 100%">
                        <div class="content-item">
                            <slot name="item" :item="item" :index="index"></slot>
                        </div>
                    </div>
                </div>
            </app-perfect-scrollbar>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import PopoverComponent from '../Utilities/Popover.vue'
    import Scrollbar from "smooth-scrollbar";

    export default {
        data(){
            return {
                isInputing: false,
                closeTimeout: null,
                valueBefore: ''
            }
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            horizontalOffset: {
                type: Number,
                default: 0
            },
            verticalOffset: {
                type: Number,
                default: 0
            },
            value: {
                type: String,
                default: ''
            },
            notFoundMessage: {
                type: String,
                default: ''
            },
            searchType: {
                type: String
            },
            forceVisible: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onSearchItemClick(item){
                this.$emit('select',item)
                this.closeSearch()
            },
            closeSearch() {
                this.$refs.popover.closePopover()
            },
            openSearch() {
                if(this.items.length) {
                    if(this.$refs.popover) this.$refs.popover.openPopover()
                }
                else this.closeSearch()
            },
            onMouseLeave() {
                this.closeTimeout = setTimeout(() => {
                    this.closeSearch();
                }, 1200);
            },
            onMouseOver() {
                if(this.closeTimeout) clearTimeout(this.closeTimeout)
            }
        },
        component: {
            'app-popover': PopoverComponent
        },
        mounted(){
            this.valueBefore = this.value
        },
        beforeDestroy(){
        }
    }
</script>

<style lang="scss" scoped>
    .content-item {
        padding: 10px 0;
        cursor: pointer; 
        border-bottom: 1px solid rgba(255,255,255,.05);

    }
    .search-result--row:last-child {
        margin-bottom: 20px;
        .content-item {
            border-bottom: 0;
        }
    }
</style>

<style>
    em {
        color: #4D76C8;
        background-color: rgba(255,255,255,.05);
        font-style: initial;
        font-weight: 600;
    }
</style>
